import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const StartToTileWrapper = styled.div(
    ({ theme: { palette, radius } }) => css`
        background-color: ${palette.tertiary.background};
        border-radius: ${radius['8']}px;
        min-height: 100px;
        padding: 16px 24px;
    `,
);

export const TileHeader = styled.div`
    align-items: center;
    display: grid;
    grid-template-columns: auto 1fr auto;
    margin-bottom: 4px;
`;

export const TileDescription = styled(Typography.TextBody_14_20)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.secondary};
    `,
);

export const TileTitle = styled(Typography.TextBody_12_18)`
    margin-left: 8px;
    text-transform: uppercase;
`;
